import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingControls } from 'teacher-ui-client/components/reporting/controls'
import { ReportingControlsGap } from 'teacher-ui-client/components/reporting/controls-gap'
import { ReportingPeriodSelect } from 'teacher-ui-client/components/reporting/period-select'
import { ReportingExportSelect } from 'teacher-ui-client/components/reporting/export-select'
import RouteTemplate from 'ember-route-template'
import type ReportingUiScopeMathseedsPrimeDashboardStudentRoute from 'teacher-ui-client/reporting/ui-scope/mathseeds-prime/dashboard-student/route'
import { StudentSearchComponent } from 'teacher-ui-client/components/student-search'
import { t } from 'ember-intl'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import { exportOptionsFromRouteInfo } from 'teacher-ui-client/utils/routing'

interface Signature {
  Args: {
    model: ModelFor<ReportingUiScopeMathseedsPrimeDashboardStudentRoute>
  }
}
export class ReportingUiScopeMathseedsPrimeDashboardStudentPage extends Component<Signature> {
  @service router!: RouterService

  get exportOptions() {
    return exportOptionsFromRouteInfo(this.router.currentRoute)
  }

  <template>
    <ReportingTeacherUiHeader
      @title={{t "pages.reporting.mathseedsPrime.dashboard.student.title" name=@model.student.fullName}}
    />
    <ReportingControls>
      <ReportingPeriodSelect data-test-dashboard-date-range-picker />
      <ReportingControlsGap />
      <ReportingExportSelect @exportOptions={{this.exportOptions}} />
      <ReportingControlsGap />
      <StudentSearchComponent
        @studentRouteName="reporting.ui-scope.mathseeds-prime.dashboard-student"
        @classRouteName="reporting.ui-scope.mathseeds-prime.dashboard-table"
        @students={{@model.scopedStudents}}
        @excludedStudent={{@model.student}}
        @includeSelectAll={{true}}
      />
    </ReportingControls>
    {{outlet}}
  </template>
}

export default RouteTemplate(ReportingUiScopeMathseedsPrimeDashboardStudentPage)
